/* tslint:disable */
/* eslint-disable */
export enum AutomaticPauseType {
  CountingOrders = 'COUNTING_ORDERS',
  WeightedItems = 'WEIGHTED_ITEMS'
}
